var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutDecorFirstBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 92,
    viewBox: "0 0 154 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.141 22.9585L149.35 68.3537H96.932L123.141 22.9585Z",
    fill: "#FEB12F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3538 63.6577L80.5545 84.79H56.1531L68.3538 63.6577Z",
    fill: "#FEB12F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1317,
    cy: 15.1317,
    r: 14.1317,
    stroke: "#5D5CDC",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutDecorFirstBlock);
export default __webpack_public_path__ + "static/media/about-decor-first-block.03f272c2da54338e6d01e623893f76d8.svg";
export { ForwardRef as ReactComponent };